import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

import css from "./MenuCategoriesNewCategoryModal.module.css";
import { menuCategoriesService } from "../../../../services/settings-services";
import { menuCategoriesActions } from "../../../../store/slices/settings-slices";
import { getConfig } from "../../../../config";

const MenuCategoriesNewCategoryModal = ({ setIsOpen }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { cityCode } = getConfig();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

  const submitHandler = async (data) => {
    try {
      await menuCategoriesService.createCategory({ name: data });
      dispatch(menuCategoriesActions.changeTrigger());
      toast.success(t("modal-toast-settings-category-successfully"));
      setIsOpen(false);
    } catch (error) {
      console.error("Error creating category:", error);
      toast.error(t("modal-toast-creating-error"));
    }
  };

  return (
    <section className={css.wrap}>
      <div className={css.modal}>
        <button className={css.closeButton} onClick={() => setIsOpen(false)}>
          &times;
        </button>
        <h2 className={css.title}>{t("modal-settings-new-category")}</h2>
        <form onSubmit={handleSubmit(submitHandler)}>
          <article className={css.inputGroup}>
            <label htmlFor="en">
              {t("modal-name-input-new-category")} (English)
            </label>
            <input
              type="text"
              id="en"
              {...register("en", { required: "Name (English) is required" })}
              className={errors.en ? css.inputError : ""}
            />
            {errors.en && <p className={css.error}>{errors.en.message}</p>}
          </article>

          <article className={css.inputGroup}>
            <label htmlFor="ru">
              {t("modal-name-input-new-category")} (Русский)
            </label>
            <input
              type="text"
              id="ru"
              {...register("ru", { required: "Name (Русский) is required" })}
              className={errors.ru ? css.inputError : ""}
            />
            {errors.ru && <p className={css.error}>{errors.ru.message}</p>}
          </article>

          {cityCode === "UAE" ? (
            <>
              <article className={css.inputGroup}>
                <label htmlFor="ar">
                  {t("modal-name-input-new-category")} (العربية)
                </label>
                <input
                  type="text"
                  id="ar"
                  {...register("ar", {
                    required: "Name (العربية) is required",
                  })}
                  className={errors.ar ? css.inputError : ""}
                />
                {errors.ar && <p className={css.error}>{errors.ar.message}</p>}
              </article>
            </>
          ) : (
            <>
              <article className={css.inputGroup}>
                <label htmlFor="ge">
                  {t("modal-name-input-new-category")} (ქართული)
                </label>
                <input
                  type="text"
                  id="ge"
                  {...register("ge", {
                    required: "Name (ქართული) is required",
                  })}
                  className={errors.ge ? css.inputError : ""}
                />
                {errors.ge && <p className={css.error}>{errors.ge.message}</p>}
              </article>
            </>
          )}

          <button className={css.submitButton} disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Ok"}
          </button>
        </form>
      </div>
    </section>
  );
};

export { MenuCategoriesNewCategoryModal };
